import styles from './FooterCopyright.module.scss';
import cx from 'classnames';

interface FooterCopyrightProps {
  text: string;
  isFooterLinksSortActive: boolean;
}

export const FooterCopyright = ({
  text,
  isFooterLinksSortActive
}: FooterCopyrightProps) => (
  <p
    className={cx(
      styles['footer__copyright-p'],
      isFooterLinksSortActive
        ? styles['footer__copyright__alignment__sort-p']
        : styles['footer__copyright__alignment-p']
    )}
  >
    {text}
  </p>
);
